import React, { useEffect, useState, useContext, useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
	AppBar,
	Box,
	IconButton,
	Toolbar,
	Button,
	Grid,
	Backdrop,
	InputLabel,
	ButtonGroup,
	Tooltip,
	Typography,
	ClickAwayListener
} from '@material-ui/core';
import { colors } from 'theme/color-palette';
import { UserPortalContext } from 'context/appcontext';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import PeviewElements from './preview-elements/PeviewElements.component';
import FilterForm from './filter/FilterForm.component';
import PreviewTable from './preview-table/PreviewTable.component';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useSelector, useDispatch } from 'react-redux';
import previewStyle from './Preview.style';
import { getTmplName, isCustomDataset, checkIfDayGrainIsSelectedMTS } from 'helper/utils';
import {
	getPreview,
	getRowCount,
	setPrevSelectedList,
	setPrevFilterList,
	clearPreviewLoaded,
	setSelectedList,
	setFilterList,
	clearPreview,
	setMenu,
	saveDraft,
	draftPrevSelectedList,
	draftPrevFilterList,
	draftPrevPivotOption,
	resetDraft,
	resetSavedDraftStatus,
	addPreviewColumn,
	saveItemShareStatus,
	getPinnedAttribute,
	savePinnedAttribute,
	setPinnedAttributeSnackbar,
	resetPivotOptions,
	getVisualHierarchyData,
	clearUnSelectedItemsFilters
} from './Preview.actions';
import {
	REPORT,
	PREVIEW,
	SAVE_BUTTON,
	DC_TMPT_LIST,
	STR_TMPT_LIST,
	LOADING_MSG,
	SHARED,
	WK_SPEC_TMPT,
	CANCEL_BUTTON,
	BLOCKED_PREVIEW_DIALOG_CONTENT,
	OK,
	CANNED_REPORT_LIST,
	REGISTER_SALES_LIST,
	OPTIONS,
	MENU,
	DONT_SAVE,
	DRAFT_NAME_TITLE,
	DRAFT_NAME_CONTENT,
	DRAFT_SAVE_TITLE,
	DRAFT_SAVE_CONTENT,
	DRAFT_SAVED,
	CONTINUE,
	BACK_WARN_MSG,
	BACK_WARN_NOTE,
	DRAFT_ERROR_MSG,
	DRAFT_LIMIT_ERROR,
	MAX_SAVE_DRAFT,
	COLUMNS,
	HEADER_SELECT_FROM_ALL,
	PREVIEW_TOOLTIP_FOR_BASIC,
	LEARN_MORE,
	LUMINATE_PLANS_LINK,
	DC_ATTR_LIST,
	SSI_ATTR_LIST,
	DIALOG_CONTENT,
	KEEP_PREVIEW,
	APPLY_FILTER,
	DIALOG_TITLE_SSI,
	BLOCKED_PREVIEW_DIALOG_CONTENT_SSI,
	ENTERPRISE_INVENTORY,
	EIPreviewTooltipMessage,
	ENTERPRISE_INVENTORY_DEFAULT_FILTER as EIDefaultFilters,
	GOT_IT_BTN,
	PIN_MAX_LIMIT_MESSAGE,
	GREGORIAN_CALENDAR,
	MULTI_TIME_SELECTION,
	WALMART_CALENDAR,
	ECOM_INVENTORY,
	FUTURE_VALID_LIST,
	SHOW_AS_CANNED_REPORT,
	PIVOT_MTS_VALUE,
	TIME_BUSINESS_NAMES,
	MOD_ONLY_POPUP_TEXT,
	SAVE_SUCCESSFUL,
	DATASET_EXISTS,
	INITIAL_SSI_COMPATIBILITY,
	INCOMPATIBILITY_ATTRIBUTE,
	PERSONA,
	COMPANYNAME,
	WEEK_KEY,
	FILTER_FROM_ALL_DATA,
	EDIT_FILTER_FROM_COLUMNS,
	LINK_ITEM_ACTIVITY,
	LINK_ITEMS_ACTIVITY,
	FILTER_LOWER,
	COLUMNS_LOWER,
	PREVIEW_NOT_AVAILABLE_TOOLTIP,
	ABC,
	QUICK_ITEM_INFORMATION_IDS,
	PREVIEW_STATUS,
	INCOMPATIBILITY_BACKROOM_INVENTORY_ATTRIBUTES,
	CATALOG_ITEM_ID_INCOMPATIBILITY,
	TO_DATE_KEY
} from 'constants/constant';
import SaveOutlinedIcon from '@material-ui/icons/SaveOutlined';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import CreateReportIcon from 'assets/svgs/create-report-icon.svg';
import { PreviewElementContext } from './Preview.context';
import DialogBox from '../Shared/DialogBox';
import { isCalFamily, isMTS, isMTSAndNotDefault, isMultiWeekSel } from './filter/FilterCondition';
import Loader from './loader/Loader.component';
import { deepClone, compareObj, _isEqual, hasOwn } from 'helper/helper';
import { editReport } from 'components/Dashboard/Dashboard.actions';
import {
	setSelectedTemplate,
	resetSaveSuccessFlag,
	setCustomDatasetName
} from 'components/Template/Template.actions';
import {
	resetFirstTimeUsrStatus,
	setStartTour as setStartTourAction
} from 'components/UserTour/Tour.action';
import ScheduleMenu from './schedule-menu/ScheduleMenu.component';
import { trackPageInfo, trackEventInfo } from 'helper/analytics';
import { PAGE_ID, EVENTS, ACTION_ON } from 'constants/tracker';
import { FEATURES } from 'helper/basicFeatureFlag';
import {
	isSSIAndDCDaily,
	getRequestBody,
	isDefaultFilter,
	hasPivotedColumn,
	validateDimFilters,
	countDimensionFilter,
	hasTimeAcross
} from './Preview.utils';
import LinkedItemsForm from './linked-items/LinkedItemsForm.component';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import classNames from 'classnames';
import HelpMenu from './help';
import TourStarter from './TourStarter.component';
import { getFirstTimeUsrStatus } from 'components/UserTour/Tour.action';
import RBSnackbar from 'components/Shared/RBSnackbar';
import TableChartOutlinedIcon from '@material-ui/icons/TableChartOutlined';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { setDatasetExistsFlag } from 'components/Template/Template.actions';
import { isCustomDatasetModular, getBaseUrl } from 'helper/utils';

const Preview = () => {
	const portalUserContext = useContext(UserPortalContext);
	const { userDetails, customerType } = portalUserContext;
	const { companyName, userPersona } = userDetails?.result;
	const [show, setShow] = useState(true);
	const [showModOnlyPopup, setShowModOnlyPopup] = useState({ showPopup: false, e: null });
	const [usrSelection, setUsrSelection] = useState([]);
	const [totalSelected, setTotalSelected] = useState(0);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const isSmallScreen = useMediaQuery('(max-width:360px)');
	const classes = previewStyle({ isSmallScreen });
	const [selectedListCount, setSelectedListCount] = useState({});
	const [openDialog, setOpenDialog] = useState(false);
	const [isBackClicked, setIsBackClicked] = useState(false);
	const [anchorEl, setAnchorEl] = useState(null);
	const [drawerContent, setDrawerContent] = useState(COLUMNS_LOWER);
	const [isPreviewTooltipOpen, setIsPreviewTooltipOpen] = useState(false);
	const [isLinkedItemPanelOpened, setIsLinkedItemPanelOpened] = useState(false);
	const [openDrawer, setOpenDrawer] = useState(true);
	const [isColumnPanelOpened, setIsColumnPanelOpened] = useState(true);
	const [showDraftDialog, setShowDraftDialog] = useState(false);
	const [templateName, setTemplateName] = useState();
	const [draftDialog, setDraftDialog] = useState(null);
	const [isSaveClicked, setIsSaveClicked] = useState(false);
	const [isSaveExitClicked, setSaveExitClicked] = useState(false);
	const [openSnackbar, setSnackbar] = useState({ open: false, msg: '' });
	const [createReportAnchor, setCreateReportAnchor] = useState(null);
	const [isFilterPanelOpened, setIsFilterPanelOpened] = useState(false);
	const [tooltipOpen, setTooltipOpen] = useState(false);
	const [openDCAttrDialog, setOpenDCAttrDialog] = useState({ status: false, for: '' });
	const [openSSIAttrDialog, setOpenSSIAttrDialog] = useState({ status: false, for: '' });
	const [particularAttrList, setParticularAttrList] = useState([]);
	const [warnToAddDimensionDialog, setWarnToAddDimensionDialog] = useState(false);
	const [otifDialog, setOTIFDialog] = useState(false);
	// const [OpenActualMtrcDialog, setOpenActualMtrcDialog] = useState({ status: false, for: '' });
	const [filterTooltip, setFilterTooltip] = useState({ show: false, msg: '' });
	const selectedTemplate = useSelector((state) => state.templateReducer.selectedTemplate);
	const defaultDlyFilter = useSelector((state) => state.templateReducer.defaultDlyFilter);
	const defaultWklyFilter = useSelector((state) => state.templateReducer.defaultWklyFilter);
	const defaultMultiWklyFilter = useSelector(
		(state) => state.templateReducer.defaultMultiWklyFilter
	);
	const { previewLoading: isPreviewLoading, isPreviewLoaded } = useSelector(
		(state) => state.previewReducer
	);
	const customDatasetName = useSelector((state) => state.templateReducer.customDatasetName);
	const previewData = useSelector((state) => state.previewReducer.previewData);
	const selectedList = useSelector((state) => state.previewReducer.selectedList);
	const filterList = useSelector((state) => state.previewReducer.filterList);
	const prevSelectedList = useSelector((state) => state.previewReducer.prevSelectedList);
	const previewErrorCode = useSelector((state) => state.previewReducer.previewErrorCode);
	const { draftSelectedList, draftFilterList, pinnedAttribute, pivotOpts, draftPivotColumn } =
		useSelector((state) => state.previewReducer);
	const rowCountErrorCode = useSelector((state) => state.previewReducer.rowCountErrorCode);
	const prevFilterList = useSelector((state) => state.previewReducer.prevFilterList);
	const selectedView = useSelector((state) => state.templateReducer.selectedView);
	const { isEditEnabled, editData, tabValue, reportTypeTabValue, savedReportsList } = useSelector(
		(state) => state.dashboardReducer
	);
	const customDatasetDetails = useSelector((state) => state.templateReducer.customDatasetDetails);
	const templateData = useSelector((state) => state.templateReducer.templateData);
	const savedCustomDatasets = useSelector((state) => state.templateReducer.savedCustomDatasets);
	const cannedReportData = useSelector((state) => state.templateReducer.cannedReportData);
	const rowCountRequest = useSelector((state) => state.previewReducer.rowCountRequest);
	// eslint-disable-next-line prettier/prettier
	const {
		DISABLE_PREVIEW: disablePreview,
		ROW_COUNT_PARAM_REQUIRED: isRowCountParamRequired,
		ENABLE_PINNED_ATTRIBUTE: enablePinnedAttribute
	} = FEATURES[customerType].PREVIEW_PAGE;
	const linkItemActivity = useSelector((state) => state.previewReducer.linkItemActivity);
	const visualHierarchyList = useSelector((state) => state.previewReducer.visualHierarchyList);
	const customAttribute = useSelector((state) => state.templateReducer.customAttribute);
	const { isFirstTimeUser, showTourStarter } = useSelector((state) => state.tourReducer);
	const { draftName, draftId, isDraftSaved, draftErrorCode } = useSelector(
		(state) => state.previewReducer
	);
	const { itemShareStatus } = useSelector((state) => state.previewReducer);
	const [ssiCompatibility, setSSIInCompatibility] = useState(INITIAL_SSI_COMPATIBILITY);
	const sbuDBTechNames = useSelector((state) => state.templateReducer.sbuDimDBTechName);
	const isSaveSuccessForDataset = useSelector(
		(state) => state.templateReducer.isSaveSuccessForDataset
	);
	const isDatasetPresent = useSelector((state) => state.templateReducer.isDatasetPresent);
	const pivotColumn = pivotOpts?.pivotColumn;

	let mtsSubAttr = templateData
		?.find((template) => template?.templateId === selectedTemplate)
		?.time?.find((timeAttr) => timeAttr?.businessName === WALMART_CALENDAR)
		?.subAttributes?.find((attr) => attr?.businessName === WEEK_KEY);
	if (mtsSubAttr) {
		mtsSubAttr = { ...mtsSubAttr, localName: MULTI_TIME_SELECTION, parent: WALMART_CALENDAR };
	}
	const areRequiredFiltersApplied = useMemo(() => {
		let isFilterApplied = true;
		filterList.forEach((item) => {
			if (isDefaultFilter(item, selectedList, sbuDBTechNames, selectedTemplate)) {
				if (isMTS(item)) {
					isFilterApplied &= isMTSAndNotDefault(item);
				} else {
					isFilterApplied &= item.field !== undefined;
				}
			}
		});
		return isFilterApplied;
	}, [filterList, selectedList]);

	const atLeastOneFilterApplied = useMemo(() => {
		return filterList.some((item) => {
			if (isMTS(item)) {
				return isMTSAndNotDefault(item);
			} else {
				return item.field !== undefined;
			}
		});
	}, [filterList]);

	const isDimenMsurSelected = useMemo(() => {
		return selectedList?.some((el) => !isCalFamily(el));
	}, [selectedList]);

	const shouldDisable = useCallback(
		(forPreview = false) => {
			//Preview Button is disabled when selecting custom data set
			if (forPreview && isCustomDataset(selectedTemplate)) {
				return true;
			}
			// Preview button is disabled for Basic user
			if (disablePreview && forPreview) {
				return true;
			}
			/**  Disbale preview button if canned report is being customized */
			if (forPreview && CANNED_REPORT_LIST.includes(Number(selectedTemplate))) {
				return true;
			}
			if (forPreview && FUTURE_VALID_LIST.includes(Number(selectedTemplate))) {
				return !atLeastOneFilterApplied;
			}
			if (forPreview && QUICK_ITEM_INFORMATION_IDS.includes(Number(selectedTemplate))) {
				return !atLeastOneFilterApplied;
			}
			if (!areRequiredFiltersApplied) {
				return true;
			}
			if (!isDimenMsurSelected) {
				return true;
			}

			if (forPreview) {
				// Preview is disabled for Pivot column selection
				if (hasPivotedColumn(pivotColumn)) {
					return true;
				}

				// Preview button is disabled for Basic user
				if (disablePreview) {
					return true;
				}

				if (itemShareStatus.curr !== itemShareStatus.prev) {
					return false;
				}

				if (isPreviewLoaded) {
					return true;
				}

				if (isEditEnabled) {
					return false;
				}

				const isSelChg = compareObj(selectedList, prevSelectedList);
				const isSFilterChg = compareObj(filterList, prevFilterList);
				if (isSelChg && isSFilterChg) {
					return true;
				}
			}

			return false;
		},
		[
			filterList,
			pivotColumn,
			selectedList,
			prevSelectedList,
			prevFilterList,
			isPreviewLoaded,
			itemShareStatus,
			selectedTemplate
		]
	);

	const isPreviewDisabled = useCallback(() => {
		return updatedDraft(true);
	}, [
		filterList,
		selectedList,
		draftSelectedList,
		draftFilterList,
		draftPivotColumn,
		pivotOpts.pivotColumn
	]);

	const isSaveDisabled = useCallback(() => {
		return updatedDraft(false);
	}, [
		filterList,
		selectedList,
		draftSelectedList,
		draftFilterList,
		draftPivotColumn,
		pivotOpts.pivotColumn
	]);

	const updatedDraft = (isPreview) => {
		// If it is "Save" button and it is an unsaved custom template report, then disable the "save" button
		if (!isPreview && selectedTemplate === -1) {
			return true;
		}
		if (isPreview && CANNED_REPORT_LIST.includes(Number(selectedTemplate))) {
			return true;
		}
		if (!areRequiredFiltersApplied) {
			return true;
		}
		if (!isDimenMsurSelected) {
			return true;
		}

		/** Below extraction of business name and compare,
		 *  will help while comparing custom attributes, otherwise
		 *  compareObj will always return false.
		 */
		const lSelectedList = selectedList.map((el) => el.businessName);
		const lDraftSelectedList = draftSelectedList.map((el) => el.businessName);
		const lPrevSelectedList = prevSelectedList.map((el) => el.businessName);
		// const lPrevFilterList = prevFilterList.map((el) => el.businessName);

		// for edit of saved report
		let isSelChg = compareObj(lSelectedList, lDraftSelectedList);
		let isSFilterChg = compareObj(filterList, draftFilterList);
		const isPivotChg = draftPivotColumn === pivotOpts.pivotColumn;

		if (isPreview) {
			if (isSelChg && isSFilterChg) {
				return true;
			}
		} else {
			if (isSelChg && isSFilterChg && isPivotChg) {
				return true;
			}
		}

		if (isPreview) {
			// for edit of active report
			isSelChg = compareObj(lSelectedList, lPrevSelectedList);
			isSFilterChg = compareObj(filterList, prevFilterList);
			if (isSelChg && isSFilterChg) {
				return true;
			}
		}

		return false;
	};

	let enablePinned = true;
	if (isCustomDataset(selectedTemplate) || !enablePinnedAttribute) {
		enablePinned = false;
	}

	useEffect(() => {
		if (isSaveSuccessForDataset && !openSnackbar.open) {
			setSnackbar({ open: true, msg: SAVE_SUCCESSFUL, type: 'dark', hideDuration: 3000 });
			dispatch(resetSaveSuccessFlag());
		} else if (isDatasetPresent && !openSnackbar.open) {
			setSnackbar({ open: true, msg: DATASET_EXISTS, type: 'dark', hideDuration: 3000 });
			dispatch(setDatasetExistsFlag(false));
		}
	}, [isSaveSuccessForDataset, isDatasetPresent]);

	useEffect(() => {
		const allData = [...templateData, ...cannedReportData];
		const result = allData.filter((item) => item.templateName === getTmplName(selectedTemplate));
		const _tmpltName = result[0]?.templateName;
		setTemplateName(_tmpltName);
		trackPageInfo(PAGE_ID['PREVIEW']);
		dispatch(getFirstTimeUsrStatus({ companyName }));
		/**
		 * Get Visual Hierarchy for SSI Template and Custom Datasets
		 * Do not call if data is already Present
		 */
		const getVisualHierarchy =
			visualHierarchyList.length === 0 &&
			(STR_TMPT_LIST.includes(Number(selectedTemplate)) || isCustomDataset(selectedTemplate));
		if (getVisualHierarchy) {
			dispatch(getVisualHierarchyData({ companyName }));
		}
		setIsBackClicked(false);
		setSaveExitClicked(false);
		if (DC_TMPT_LIST.includes(Number(result[0]?.templateId))) {
			setParticularAttrList(DC_ATTR_LIST);
		} else if (STR_TMPT_LIST.includes(Number(result[0]?.templateId))) {
			setParticularAttrList(SSI_ATTR_LIST);
		}
		if (selectedTemplate && ENTERPRISE_INVENTORY.includes(Number(selectedTemplate))) {
			setFilterTooltip({
				show: true,
				msg: <Typography style={{ fontSize: '14px' }}>{EIPreviewTooltipMessage}</Typography>
			});
		}
		addInCompatibility();

		/**
		 * Get Pinned attributes based on Template id
		 */
		if (selectedTemplate && enablePinned) {
			dispatch(getPinnedAttribute({ templateId: selectedTemplate, companyName }));
		}
	}, []);

	/**
	 * Pinned attributes
	 * - Showing Snackbar
	 * - Saving Pinned attributes
	 */
	useEffect(() => {
		if (pinnedAttribute.showSnackbar) {
			setSnackbar({ open: true, msg: PIN_MAX_LIMIT_MESSAGE, type: 'dark', hideDuration: 3000 });
			// Update showSnackbar store flag to false, so that next time user pins an attribute, snackbar shows
			dispatch(setPinnedAttributeSnackbar(false));
		}
	}, [pinnedAttribute.showSnackbar]);

	const savePinnedAttributeChanges = () => {
		const pinnedAttributeList = pinnedAttribute[selectedTemplate] || {};
		dispatch(
			savePinnedAttribute({
				companyName,
				pinnedAttributeList,
				templateId: selectedTemplate,
				templateName: getTmplName(selectedTemplate)
			})
		);
	};

	useEffect(() => {
		const allData = [...templateData, ...cannedReportData];
		const OTIF_Dialog_popup = localStorage.getItem('OTIF_Dialog_popup');
		const result = allData.filter((item) => item.templateName === getTmplName(selectedTemplate));
		if (result?.[0]?.templateName === 'OMNI OTIF' && !OTIF_Dialog_popup) {
			setOTIFDialog(true);
		}
	}, [templateData, cannedReportData, selectedTemplate]);

	/**
	 * Tour start screen & guides
	 */
	useEffect(() => {
		if (isFirstTimeUser && !JSON.parse(localStorage.getItem('PreviewElementTourSkip'))) {
			dispatch(
				setStartTourAction({
					showTourStarter: true
				})
			);
		}
	}, [isFirstTimeUser]);

	const onTourStart = () => {
		dispatch(
			setStartTourAction({
				showTourStarter: false,
				showPreviewElementsTour: true
			})
		);
	};

	useEffect(() => {
		if (draftErrorCode === 505) {
			setSnackbar({ open: true, msg: DRAFT_ERROR_MSG, type: 'error', guidedBtn: false });
		}
	}, [draftErrorCode]);

	useEffect(() => {
		if (selectedTemplate === null && !isEditEnabled) {
			navigate('/');
			return;
		}
		if (selectedTemplate === null) {
			navigate('/rbtemplates');
		}
	}, [selectedTemplate]);

	useEffect(() => {
		if (isDraftSaved && !isEditEnabled) {
			setSnackbar({ open: true, msg: DRAFT_SAVED, guidedBtn: false, type: 'success' });
		}
	}, [isDraftSaved]);

	const handleShow = (fromWhere, shouldKeepOpen = false, childPanel = false) => {
		const hideRightPanel = () => {
			setOpenDrawer(false);
			setDrawerContent('');
			setIsLinkedItemPanelOpened(false);
			setIsColumnPanelOpened(false);
			setIsFilterPanelOpened(false);
			setShow(false);
		};

		if (
			fromWhere === LINK_ITEM_ACTIVITY ||
			fromWhere === COLUMNS_LOWER ||
			fromWhere === FILTER_LOWER
		) {
			if (fromWhere === LINK_ITEM_ACTIVITY) {
				if (drawerContent === LINK_ITEMS_ACTIVITY) {
					hideRightPanel();
				} else {
					setOpenDrawer(true);
					setDrawerContent(LINK_ITEMS_ACTIVITY);
					setIsLinkedItemPanelOpened(true);
					setIsColumnPanelOpened(false);
					setIsFilterPanelOpened(false);
					setShow(false);
				}
			} else if (fromWhere === COLUMNS_LOWER) {
				if (
					(drawerContent === COLUMNS_LOWER || drawerContent === EDIT_FILTER_FROM_COLUMNS) &&
					!shouldKeepOpen
				) {
					hideRightPanel();
				} else {
					setOpenDrawer(true);
					childPanel ? setDrawerContent(EDIT_FILTER_FROM_COLUMNS) : setDrawerContent(COLUMNS_LOWER);
					setIsLinkedItemPanelOpened(false);
					setIsColumnPanelOpened(true);
					setIsFilterPanelOpened(false);
					setShow(true);
				}
			} else if (fromWhere === FILTER_LOWER) {
				if (
					(drawerContent === FILTER_LOWER || drawerContent === FILTER_FROM_ALL_DATA) &&
					!shouldKeepOpen
				) {
					hideRightPanel();
				} else {
					setOpenDrawer(true);
					childPanel ? setDrawerContent(FILTER_FROM_ALL_DATA) : setDrawerContent(FILTER_LOWER);
					setIsLinkedItemPanelOpened(false);
					setIsColumnPanelOpened(false);
					setIsFilterPanelOpened(true);
					setShow(false);
				}
			}
		} else {
			setIsLinkedItemPanelOpened(false);
			setIsColumnPanelOpened(true);
			setIsFilterPanelOpened(false);
			setDrawerContent(COLUMNS_LOWER);
			setShow(!show);
		}
	};

	const dispatchSelectedList = (param) => {
		dispatch(setSelectedList(param));
	};
	const getParentCompName = (isGregorian) => {
		const obj = {};
		let key = defaultDlyFilter;
		const value = userPersona === PERSONA.CATMAN ? PERSONA.CATMAN : COMPANYNAME;
		const isMultiWeek = filterList?.some(
			(el) => isMultiWeekSel(el, Number(selectedTemplate)) || isMTS(el)
		);
		let isWeekSel = filterList?.some((el) => el.businessName === WEEK_KEY);
		const isSSI = STR_TMPT_LIST.includes(Number(selectedTemplate));
		const isDCMetrics = DC_TMPT_LIST.includes(Number(selectedTemplate));
		const isRegSales = REGISTER_SALES_LIST.includes(Number(selectedTemplate));
		if (isSSI || isDCMetrics || isRegSales) {
			isWeekSel = !isSSIAndDCDaily(selectedList, filterList);
		}
		if (isGregorian) {
			isWeekSel = false;
		}
		if (isMultiWeek) {
			key = defaultMultiWklyFilter;
		} else if (WK_SPEC_TMPT.includes(Number(selectedTemplate)) && isWeekSel) {
			key = defaultWklyFilter;
		}
		if (userPersona !== PERSONA.MERCHANT) {
			obj[key] = value;
		}
		return obj;
	};

	const handleBack = () => {
		if (enablePinned) {
			savePinnedAttributeChanges();
		}
		// Reset Pivot options
		if (pivotColumn) {
			dispatch(resetPivotOptions());
		}
		let isSomethingChanged = true;
		const isSelChg = compareObj(selectedList, prevSelectedList);
		const isSFilterChg = compareObj(filterList, prevFilterList);
		// if both true => then no change
		if (isSelChg && isSFilterChg) {
			isSomethingChanged = false;
		}

		if (isEditEnabled) {
			if (isSomethingChanged && !isPreviewDisabled()) {
				dispatch(resetFirstTimeUsrStatus());
				setIsBackClicked(true);
				setOpenDialog(true);
				return;
			}
			dispatch(editReport({ isEditEnabled: false, editData: {}, action: null }));
			dispatch(setSelectedTemplate({ templateId: null, view: null, filter: undefined }));
			return;
		}
		if (!isPreviewDisabled()) {
			dispatch(resetFirstTimeUsrStatus());
			setIsBackClicked(true);
			setOpenDialog(true);
			return;
		}
		dispatch(resetFirstTimeUsrStatus());
		if (customDatasetName) {
			dispatch(setCustomDatasetName(''));
		}
		navigate('/rbtemplates');
	};

	const getCommonParams = (
		newSelectionList = selectedList,
		newFilterList = filterList,
		isRowCountCall = false
	) => {
		const isGregorian = filterList?.some((filter) => filter?.parent === GREGORIAN_CALENDAR);
		const parentName = getParentCompName(isGregorian);

		// Newly created CDS are stored in "savedCustomDatasets" and not in templateData
		// Therefore we need to build a CDS with all the required attributes such as "dimensions" using the newly created CDS
		// Reference story: DSIDVL-36884
		const savedCustomDatasetsWithDefaults = (savedCustomDatasets ?? []).map((savedCDS) => {
			const result = {
				...savedCDS,
				sortOrder: 1,
				folderNames: [...(savedCDS?.tables ?? customDatasetDetails.tableNames)],
				dimensions: [],
				measures: [],
				filter: customDatasetDetails.filter,
				filterWeekly: customDatasetDetails.filterWeekly,
				filterWeeklyMultiWindow: customDatasetDetails.filterWeeklyMultiWindow,
				view: customDatasetDetails?.view ?? ABC,
				defaultFilters: customDatasetDetails?.defaultFilters
			};

			const selectedTableObjects = customDatasetDetails.tablesInfo.filter((tableDetail) =>
				savedCDS.tables.includes(tableDetail.tableName)
			);
			selectedTableObjects.forEach((selectedTable) => {
				if (selectedTable.dimensions) {
					result.dimensions = [...result.dimensions, ...selectedTable.dimensions];
				}
				if (selectedTable.measures) {
					result.measures = [...result.measures, ...selectedTable.measures];
				}
			});

			const isMod = isCustomDatasetModular(selectedTableObjects);

			if (!isMod) {
				result.time = customDatasetDetails?.time;
			}
			return result;
		});
		const allData = [...templateData, ...cannedReportData, ...savedCustomDatasetsWithDefaults];
		const selectedTmplData = allData.filter((item) => {
			if (
				isCustomDataset(item?.templateId) ||
				Number(item?.templateId) === Number(customDatasetDetails.templateId)
			) {
				return item?.templateId === selectedTemplate;
			} else {
				return item.templateName === getTmplName(selectedTemplate);
			}
		});

		if (!isRowCountCall) {
			// While Previewing, for EI template the snapshot hour filter should pass only one value in case of 'is equal to' condition
			if (selectedTemplate && ENTERPRISE_INVENTORY.includes(Number(selectedTemplate))) {
				// Make a copy of newFilterList, so that for rowCount call it wont take this modified filter list
				const tempNewFilterList = deepClone(newFilterList);
				// Loop through filter list to find EI default filter & the specific condition, if found then pass only one value
				for (const filterObject of tempNewFilterList) {
					if (
						EIDefaultFilters[0] === filterObject?.technicalName &&
						filterObject?.filter?.condition === 'is equal to'
					) {
						const key = Object.keys(filterObject.field)[0];
						const value = Object.values(filterObject.field)[0];
						filterObject.field = {
							...filterObject.field,
							[key]: value?.split(',')[0] || '1'
						};
						filterObject.filter.value = [filterObject.filter.value[0]];
						break;
					}
				}
				newFilterList = deepClone(tempNewFilterList);
			}
		}

		// Removes duplicates: this happens when the user works with an existing custom dataset
		// We would have the same CDS in both templateData and savedCustomDatasets
		const selectedTemplateInfo = selectedTmplData.filter(
			(tmpl1, i, arr) => arr.findIndex((tmpl2) => tmpl2?.templateId === tmpl1?.templateId) === i
		);

		return {
			isPreview: true,
			filterList: newFilterList,
			selectedTemplate,
			selectedList: newSelectionList,
			parentName,
			selectedView,
			dispatchSelectedList,
			persona: userPersona,
			selectedTmplData: selectedTemplateInfo,
			linkItemActivity,
			userDetails,
			customerType,
			itemShare: itemShareStatus.curr
		};
	};

	const callPreview = (newSelectionList, persona, newFilterList) => {
		const params = getCommonParams(newSelectionList, newFilterList);
		dispatch(
			getPreview({
				requestBody: getRequestBody({ ...params, persona, customDatasetDetails }),
				companyName,
				templateId: selectedTemplate
			})
		);
	};

	const dispatchActionOnPreview = (persona) => {
		const params = getCommonParams();
		dispatch(
			getPreview({
				requestBody: getRequestBody({ ...params, persona, customDatasetDetails }),
				companyName,
				templateId: selectedTemplate
			})
		);

		dispatch(setPrevSelectedList(deepClone(selectedList)));
		dispatch(setPrevFilterList(deepClone(filterList)));
	};

	const dispatchActionClearPreviewLoaded = () => {
		dispatch(clearPreviewLoaded());
	};

	const reloadPreview = () => {
		if (previewErrorCode === PREVIEW_STATUS.FAILURE) {
			return dispatchActionOnPreview;
		} else if (previewData?.jsonResponse.length === 0) {
			return dispatchActionClearPreviewLoaded;
		}
	};

	const warnForFilter = () => {
		if (SHOW_AS_CANNED_REPORT.includes(Number(selectedTemplate))) {
			const dimensionFilters = countDimensionFilter(filterList);
			if (dimensionFilters.length === 0) {
				return true;
			}
		}

		/**  Show the preview dialog for having at least 1 dimension filter for Merchant or if the selected report is canned report */
		if (userPersona === PERSONA.MERCHANT) {
			const dimensionFilters = countDimensionFilter(filterList);
			if (dimensionFilters.length === 0) {
				return true;
			}
		}

		/** For SSI template, if store and item related attributes are selected then we need to validate filters */
		return !validateDimFilters(selectedList, filterList, Number(selectedTemplate));
	};

	const ShowWarnToAddDimensionDialog = () => {
		let dialogProps = {
			title: 'Selection Error',
			bodyContent: 'Please add more dimensions',
			primaryBtnText: OK,
			hideTitle: false,
			hidePrimaryBtn: true,
			onPrimaryClick: cbOnDialogCancel
		};
		return <DialogBox open={warnToAddDimensionDialog} {...dialogProps} />;
	};

	const onDialogGotIt = () => {
		setOTIFDialog(false);
		localStorage.setItem('OTIF_Dialog_popup', true);
	};

	const OTIFDialog = () => {
		const dialogProps = {
			title: 'Latest update for OMNI OTIF',
			bodyContent:
				'Data from vendors that are not legally owned will no longer be available. Going forward, we recommend users to pull OTIF data at vendor level.',
			secondaryBtnText: '',
			primaryBtnText: GOT_IT_BTN,
			onSecondaryClick: () => {},
			onPrimaryClick: onDialogGotIt
		};
		dialogProps.hidePrimaryBtn = true;
		return <DialogBox open={otifDialog} {...dialogProps} />;
	};

	const updateSSIComptability = (_d) => {
		setSSIInCompatibility(_d);
	};

	const preCheckForSSInDC = (from) => {
		const isCDS = isCustomDataset(selectedTemplate);
		// If it is not DC template, SSI, ECOM Inventory or CDS, then do not execute the function.
		if (
			!(
				[...DC_TMPT_LIST, ...STR_TMPT_LIST, ...ECOM_INVENTORY, ...REGISTER_SALES_LIST].includes(
					Number(selectedTemplate)
				) || isCDS
			)
		) {
			return;
		}

		const timeObj = filterList.find((item) => isCalFamily(item));

		function validateIncompatibility() {
			/** condition are  -
			 * 1. if day grain selected and Sales attr selected with storeInvAttr
			 * 2. or Multitime selected with storeInvAttr
			 * 3. catalog item selected with other incompatible attr
			 */

			const { incompatibilityAttr, incompatibility, dataSet } = ssiCompatibility;
			let isComp = false;
			// Below logic to determine incompatibility, if dataset intersect with incompatibility, then incompatibility true else false
			for (const key in incompatibility) {
				// eslint-disable-next-line no-prototype-builtins
				if (hasOwn(dataSet, key)) {
					isComp = true;
					break;
				}
			}
			// const timeObj = filterList.find((item) => isCalFamily(item));
			const isMultiWkSelected = isMultiWeekSel(timeObj, Number(selectedTemplate));
			const isDayColumnOrFilterSelected =
				filterList.some((item) => item.businessName === 'Date') ||
				selectedList.some((item) => item.businessName === 'Date');
			// In BE, it goes to a daily grain if it is MTS 2.0 custom date (or) yesterday (or) Last weekend (or) week to date
			// (or) Month to date (or) Year to date
			const isDayGrainIsSelectedMTS = checkIfDayGrainIsSelectedMTS(timeObj);
			const isToDateColumnOrFilterSelected = filterList.some((item) =>
				item.filter.condition.includes(TO_DATE_KEY)
			);
			const isDayGrainSelected =
				isDayColumnOrFilterSelected || isDayGrainIsSelectedMTS || isToDateColumnOrFilterSelected;

			const storeInvAttr = incompatibilityAttr.some((el) => INCOMPATIBILITY_ATTRIBUTE.includes(el));
			if (storeInvAttr && isMultiWkSelected) {
				return true;
			}

			if (storeInvAttr && isDayColumnOrFilterSelected && isComp) {
				return true;
			}

			if (isComp && incompatibilityAttr.includes(CATALOG_ITEM_ID_INCOMPATIBILITY)) {
				return true;
			}
			// DSIDVL-41980: Backroom inventory adjustment columns are incompatible with columns from folders "Sales", "Inevntory" and "OPD"
			// If backroom column is selected along with incompatible columns only for daily grain.
			const isBackroomInvenAdjColumnSelected = incompatibilityAttr.some((el) =>
				INCOMPATIBILITY_BACKROOM_INVENTORY_ATTRIBUTES.includes(el)
			);
			if (isComp && isDayGrainSelected && isBackroomInvenAdjColumnSelected) {
				return true;
			}

			return false;
		}

		if (STR_TMPT_LIST.includes(Number(selectedTemplate)) || isCDS) {
			if (validateIncompatibility()) {
				const isParticularAttrSelected = selectedList.every((item) => {
					if (isCalFamily(item)) return true;
					return ssiCompatibility.incompatibilityAttr.includes(item.businessName);
				});
				if (isParticularAttrSelected) {
					return 'WARN_TO_ADD_DIMENSION';
				}
				return 'SHOW_WARN_DIALOG_SSI';
			}
			return false;
		} else {
			const isAttrSelected = selectedList.some((item) => {
				if (particularAttrList.includes(item.technicalName)) return true;
				return false;
			});

			if (isAttrSelected) {
				const calFamFromSel = selectedList.find((item) => isCalFamily(item));
				if (!calFamFromSel) {
					// const calFamilyObj = filterList.find((item) => isCalFamily(item));
					const newList = [timeObj, ...selectedList];
					dispatch(addPreviewColumn(previewData, timeObj.technicalName));
					dispatch(setSelectedList(deepClone(newList)));
					dispatch(setPrevSelectedList(deepClone(newList)));
					if (from === 'PREVIEW') {
						callPreview(newList, userPersona, filterList);
					} else {
						callRowCountApi(newList);
					}
					return 'PREVIEW_DISPATCHED';
				} else {
					/**
					 * if multi time selection then show dialogbox with cancel and continue
					 * on cancel - do nothing
					 * on continue - remove respective attr from selection list and filterlist
					 */
					// const timeObj = filterList.find((item) => isCalFamily(item));
					const isMultiWkSelected = isMultiWeekSel(timeObj, Number(selectedTemplate));
					if (isMultiWkSelected) {
						const isParticularAttrSelected = selectedList.every((item) => {
							if (isCalFamily(item)) return true;
							return particularAttrList.includes(item.technicalName);
						});
						if (isParticularAttrSelected) {
							return 'WARN_TO_ADD_DIMENSION';
						}
						return 'SHOW_WARN_DIALOG_DC';
					} else {
						return false;
					}
				}
			}
		}

		return false;
	};

	const handlePreviewClick = () => {
		hideSnackbar();

		if (warnForFilter()) {
			setOpenDialog(true);
			return;
		}

		// add time attr forcefully for SSI and DC if particular attr are in selected list
		const showAttrWarnDialog = preCheckForSSInDC('PREVIEW');
		if (showAttrWarnDialog === 'SHOW_WARN_DIALOG_SSI') {
			setOpenSSIAttrDialog({ status: true, for: 'PREVIEW' });
			return;
		} else if (showAttrWarnDialog === 'SHOW_WARN_DIALOG_DC') {
			setOpenDCAttrDialog({ status: true, for: 'PREVIEW' });
			return;
		} else if (showAttrWarnDialog === 'WARN_TO_ADD_DIMENSION') {
			/** Ask user to add more dimension other than these particular attr.
			 * because these particular attr will be removed on preview.
			 */
			setWarnToAddDimensionDialog(true);
			return;
		} else if (showAttrWarnDialog === 'PREVIEW_DISPATCHED') {
			return;
		}

		const checkDimenMsurs = filterList.filter((el) => !isCalFamily(el) && el.field !== undefined);
		if (checkDimenMsurs.length === 0) {
			setOpenDialog(true);
			return;
		}
		dispatch(saveItemShareStatus({ prev: itemShareStatus.curr }));
		dispatchActionOnPreview(userPersona);
	};

	function removeInCompatibility(value, _o) {
		if (!STR_TMPT_LIST.includes(Number(selectedTemplate))) {
			return {};
		}
		let { dataSet, incompatibility, incompatibilityAttr, incompatibilityAttrCount } = _o;
		if (value.dataSet) {
			value.dataSet.forEach((el) => {
				dataSet[el]--;
				if (dataSet[el] === 0) {
					delete dataSet[el];
				}
			});
		}

		if (value.incompatible) {
			value.incompatible.forEach((el) => {
				incompatibility[el]--;
				if (incompatibility[el] === 0) {
					delete incompatibility[el];
				}
			});

			incompatibilityAttr = incompatibilityAttr.filter((el) => el !== value.businessName);
		}

		const newIncompatibilityAttrCount = { ...incompatibilityAttrCount };
		const currentIncompatibleCount = newIncompatibilityAttrCount[value.businessName];
		if (currentIncompatibleCount > 0) {
			newIncompatibilityAttrCount[value.businessName] = currentIncompatibleCount - 1;
		}

		return {
			dataSet,
			incompatibility,
			incompatibilityAttr,
			incompatibilityAttrCount: newIncompatibilityAttrCount
		};
	}

	function addInCompatibility() {
		if (!(STR_TMPT_LIST.includes(Number(selectedTemplate)) || isCustomDataset(selectedTemplate))) {
			return {};
		}
		const _metricCal = deepClone(ssiCompatibility);
		selectedList.forEach((value) => {
			if (value.dataSet) {
				value.dataSet.forEach((el) => {
					if (!_metricCal.dataSet[el]) {
						_metricCal.dataSet[el] = 0;
					}
					_metricCal.dataSet[el]++;
				});
			}

			if (value.incompatible) {
				value.incompatible.forEach((el) => {
					if (!_metricCal.incompatibility[el]) {
						_metricCal.incompatibility[el] = 0;
					}
					_metricCal.incompatibility[el]++;
				});

				_metricCal.incompatibilityAttr.push(value.businessName);
			}
		});

		setSSIInCompatibility(_metricCal);
	}

	const handleCntdWidAttrWarn = (pList, navigateTo) => {
		let lSsiCompObj = deepClone(ssiCompatibility);
		let _nSelectionList = [];
		// This is the list of attributes that are removed. This is necessary because a column
		// can both be selected and a filter can be applied but if the incompatible column has been removed
		// from the selected list, then there's no need to remove it again when going over the filter list.
		const removedIncompatibleAttrList = {};

		selectedList.forEach((item) => {
			if (!pList.includes(item.businessName)) {
				_nSelectionList.push(item);
			} else {
				lSsiCompObj = removeInCompatibility(item, lSsiCompObj);
				removedIncompatibleAttrList[item.businessName] = true;
			}
		});

		const _nFilterList = filterList.filter((item) => {
			if (pList.includes(item.businessName) && !removedIncompatibleAttrList[item.businessName]) {
				lSsiCompObj = removeInCompatibility(item, lSsiCompObj);
			}
			return !pList.includes(item.businessName);
		});
		dispatch(setSelectedList(deepClone(_nSelectionList)));
		dispatch(setPrevSelectedList(deepClone(_nSelectionList)));
		dispatch(setPrevFilterList(deepClone(_nFilterList)));
		dispatch(setFilterList(deepClone(_nFilterList)));
		if (navigateTo === 'PREVIEW') {
			callPreview(_nSelectionList, userPersona, _nFilterList);
		} else {
			callRowCountApi(_nSelectionList, _nFilterList);
		}
		setSSIInCompatibility(lSsiCompObj);
	};

	const AttrWarningOnMTS = () => {
		const dialogProps = {
			title: 'Some data is not available',
			bodyContent: (
				<>
					<Typography>
						The following selection cannot return data due to multi-time selection, consider
						removing columns or changing the time range to single selection for a complete result:
					</Typography>
					<br></br>
					{particularAttrList.map((item, idx) => (
						<Typography key={idx} style={{ fontWeight: 'bold' }}>
							{item.replaceAll('_', ' ')}
						</Typography>
					))}
					<br></br>
					<Typography>Do you still want to continue with current selections?</Typography>
				</>
			),
			secondaryBtnText: CANCEL_BUTTON,
			primaryBtnText: 'Yes, continue',
			onSecondaryClick: () => {
				setOpenDCAttrDialog({ status: false, for: 'PREVIEW' });
			},
			onPrimaryClick: () => {
				handleCntdWidAttrWarn(particularAttrList, openDCAttrDialog.for);
				setOpenDCAttrDialog({ status: false, for: 'PREVIEW' });
			},
			showTextBox: false
		};

		return <DialogBox open={openDCAttrDialog.status} {...dialogProps} />;
	};

	/** SSI Warning on attr incompatibility */
	const AttrWarningOnSSIIncomp = () => {
		const ssiIncompatibilityAttributes = ssiCompatibility.incompatibilityAttr;
		// Case 1: if the user selects catalog Item Id and one of its incompatible attributes.
		const isFulfilmentAttr = ssiIncompatibilityAttributes.includes(CATALOG_ITEM_ID_INCOMPATIBILITY);
		let isMultiWkSelected = false,
			isDayGrainSelected = false;
		// time period
		const timeObj = filterList.find((item) => isCalFamily(item));
		if (timeObj !== undefined) {
			isMultiWkSelected = isMultiWeekSel(timeObj, Number(selectedTemplate));
			isDayGrainSelected =
				filterList.some((item) => item.businessName === 'Date') ||
				selectedList.some((item) => item.businessName === 'Date');

			// In BE, it goes to a daily grain if it is MTS 2.0 custom date (or) yesterday (or) Last weekend (or) week to date
			// (or) Month to date (or) Year to date
			const isToDateColumnOrFilterSelected = filterList.some((item) =>
				item.filter.condition.includes(TO_DATE_KEY)
			);
			isDayGrainSelected ||=
				checkIfDayGrainIsSelectedMTS(timeObj) || isToDateColumnOrFilterSelected;
		}

		// Case 2: If the user selects carry option code (or) carry status code (or) Event associated with retail price amount
		// && selects Multi week selection (or) daily grain (column/filter)
		const showSalesIncompatible =
			ssiIncompatibilityAttributes.some((el) => INCOMPATIBILITY_ATTRIBUTE.includes(el)) &&
			(isMultiWkSelected || isDayGrainSelected);
		// Case 3: If the user selects Backroom Inventory Adjustment Type Code (or) Backroom Inventory Adjustment Type Description
		// && daily grain (column/filter)
		const isBackroomInvenAdjAttr =
			ssiIncompatibilityAttributes.some((el) =>
				INCOMPATIBILITY_BACKROOM_INVENTORY_ATTRIBUTES.includes(el)
			) && isDayGrainSelected;

		const dialogProps = {
			title: 'Some data is not available',
			bodyContent: (
				<>
					<Typography>
						We are unable to display data for a few attributes due to some current limitations:
					</Typography>

					<ol className={classes.dialogboxList}>
						{showSalesIncompatible && (
							<li>
								<Typography>
									Attributes incompatible with Sales metrics, Walmart Day and multiple time periods:
								</Typography>
								{ssiIncompatibilityAttributes
									.filter((attr) => INCOMPATIBILITY_ATTRIBUTE.includes(attr))
									.map((item, idx) => (
										<Typography key={idx} style={{ fontWeight: 'bold' }}>
											{item.replaceAll('_', ' ')}
										</Typography>
									))}
							</li>
						)}
						{isFulfilmentAttr && (
							<li>
								<Typography>Attributes only available with Store Fulfillment</Typography>
								<Typography style={{ fontWeight: 'bold' }}>Catalog Item ID</Typography>
							</li>
						)}
						{isBackroomInvenAdjAttr && (
							<li>
								<Typography>
									Attributes only available with Store Inventory attributes on a Walmart or
									Gregorian Calendar <span style={{ fontWeight: 'bold' }}>Date</span> level:
								</Typography>
								{ssiIncompatibilityAttributes
									.filter((attr) => INCOMPATIBILITY_BACKROOM_INVENTORY_ATTRIBUTES.includes(attr))
									.map((item, idx) => (
										<Typography key={idx} style={{ fontWeight: 'bold' }}>
											{item.replaceAll('_', ' ')}
										</Typography>
									))}
							</li>
						)}
					</ol>

					<Typography>
						You can cancel current action to go back and adjust selections or continue with removing
						above data.
					</Typography>
				</>
			),
			secondaryBtnText: CANCEL_BUTTON,
			primaryBtnText: 'Remove data and continue',
			onSecondaryClick: () => {
				setOpenSSIAttrDialog({ status: false, for: 'PREVIEW' });
			},
			onPrimaryClick: () => {
				let attrList = [...ssiIncompatibilityAttributes];
				let exemptList = [];
				// If it is not catalog item id incompatibility, then remove it from the list.
				if (!isFulfilmentAttr) {
					attrList = attrList.filter((el) => el !== CATALOG_ITEM_ID_INCOMPATIBILITY);
				}
				// If it is not carry option code/carry status code/event associated with retail price amount incompatibility, then remove them from the list.
				if (!showSalesIncompatible) {
					attrList = attrList.filter((el) => !INCOMPATIBILITY_ATTRIBUTE.includes(el));
				}
				// If it is not Backroom Inventory Adjustment Type Code/Backroom Inventory Adjustment Type Description incompatibility, then remove them from the list.
				if (!isBackroomInvenAdjAttr) {
					attrList = attrList.filter(
						(el) => !INCOMPATIBILITY_BACKROOM_INVENTORY_ATTRIBUTES.includes(el)
					);
				} else {
					exemptList = exemptList.concat(...INCOMPATIBILITY_BACKROOM_INVENTORY_ATTRIBUTES);
				}
				handleCntdWidAttrWarn(attrList, openSSIAttrDialog.for);
				dispatch(clearUnSelectedItemsFilters(exemptList));
				setOpenSSIAttrDialog({ status: false, for: 'PREVIEW' });
			},
			showTextBox: false
		};

		return <DialogBox open={openSSIAttrDialog.status} {...dialogProps} />;
	};

	const handleShowPreview = () => {
		dispatch(saveItemShareStatus({ prev: itemShareStatus.curr }));
		dispatchActionOnPreview(userPersona);
		setOpenDialog(false);
	};

	const callRowCountApi = (newSelectionList = selectedList, newFilterList = filterList) => {
		const isRowCountCall = true;
		const params = getCommonParams(newSelectionList, newFilterList, isRowCountCall);
		const requestObj = getRequestBody({
			...params,
			persona: userPersona,
			isPreview: false,
			customDatasetDetails
		});

		if (hasPivotedColumn(pivotColumn)) {
			requestObj.pivotColumn = pivotColumn;
			/**
			 * Attach pivotColumn for rowCount Payload
			 *
			 * While applying Pivot on Single Time Attributes,
			 * If Walmart Calendar > Week is checked & multiple weeks filter applied, send Pivot MTS value to BE
			 */
			if (pivotOpts?.isMultiWeek) {
				requestObj.pivotColumn = PIVOT_MTS_VALUE;
			}
			if (hasTimeAcross(pivotOpts)) {
				requestObj.isTimeAcrossDataDown = true;
			}
		}

		/** if there is no change in request object then previous selc, then no hit. */
		if (!_isEqual(rowCountRequest, requestObj) || rowCountErrorCode !== 0) {
			dispatch(
				getRowCount({
					requestBody: requestObj,
					companyName,
					isRowCountParamRequired,
					selectedTemplate,
					templateId: selectedTemplate
				})
			);
		}
		dispatch(resetSavedDraftStatus());
		navigate('/reports');
	};

	const handleSchedule = (e) => {
		hideSnackbar();
		if (warnForFilter()) {
			setOpenDialog(true);
			return;
		}

		// add time attr forcefully for SSI and DC if particular attr are in selected list
		const showAttrWarnDialog = preCheckForSSInDC('SCHEDULE');
		if (showAttrWarnDialog === 'SHOW_WARN_DIALOG_SSI') {
			setOpenSSIAttrDialog({ status: true, for: 'SCHEDULE' });
			return;
		} else if (showAttrWarnDialog === 'SHOW_WARN_DIALOG_DC') {
			setOpenDCAttrDialog({ status: true, for: 'SCHEDULE' });
			return;
		} else if (showAttrWarnDialog === 'WARN_TO_ADD_DIMENSION') {
			/** Ask user to add more dimension other than these particular attr.
			 * because these particular attr will be removed on preview.
			 */
			setWarnToAddDimensionDialog(true);
			return;
		} else if (showAttrWarnDialog === 'PREVIEW_DISPATCHED') {
			return;
		}

		if (isEditEnabled && tabValue !== SHARED && reportTypeTabValue === 0) {
			setAnchorEl(e?.currentTarget || createReportAnchor?.target);
			return;
		}
		callRowCountApi();
		setShowDraftDialog(false);
	};

	const handleClear = () => {
		setSSIInCompatibility(INITIAL_SSI_COMPATIBILITY);
		setTotalSelected(0);
		setSelectedListCount({});
		dispatch(setSelectedList());
		dispatch(setFilterList([]));
		dispatch(clearPreview([]));
	};

	const renderDrawerContent = (drawerWidth) => {
		if (show) {
			if (drawerContent === EDIT_FILTER_FROM_COLUMNS) {
				return (
					<FilterForm
						cbSetShowPreviewElement={(
							fromWhere,
							shouldKeepOpen = false,
							shouldChildPanelOpen = false
						) => handleShow(fromWhere, shouldKeepOpen, shouldChildPanelOpen)}
						usrSelection={usrSelection}
						drawerWidth={drawerWidth}
						fromWhere="editFilter"
						mtsSubAttr={mtsSubAttr}
						ssiCompatibility={ssiCompatibility}
						cbSSIComptability={updateSSIComptability}
					/>
				);
			}
			return (
				<PreviewElementContext.Provider
					value={{
						cbSetShowPreviewElement: (fromWhere, shouldKeepOpen = false, childPanel = false) =>
							handleShow(fromWhere, shouldKeepOpen, childPanel),
						cbUsrSelection: (val) => setUsrSelection(val),
						cbSetFilterTooltip: (val) => setFilterTooltip(val)
					}}>
					<PeviewElements
						selectedListCount={selectedListCount}
						setSelectedListCount={setSelectedListCount}
						customAttribute={customAttribute}
						setTotalSelected={(val) => setTotalSelected(val)}
						totalSelected={totalSelected}
						actionOnGuidedBtn={() => handleShow(LINK_ITEM_ACTIVITY)}
						drawerWidth={drawerWidth}
						panelObjHeader={COLUMNS}
						panelObjIcon={
							<TableChartOutlinedIcon style={{ marginRight: 8, color: colors.PURPLE }} />
						}
						panelObjFromWhere="columns"
						usrSelection={usrSelection}
						cbSSIComptability={updateSSIComptability}
						ssiCompatibility={ssiCompatibility}
						mtsSubAttr={mtsSubAttr}
					/>
				</PreviewElementContext.Provider>
			);
		}

		if (drawerContent === FILTER_LOWER) {
			return (
				<FilterForm
					cbSetShowPreviewElement={(
						fromWhere,
						shouldKeepOpen = false,
						shouldChildPanelOpen = false
					) => handleShow(fromWhere, shouldKeepOpen, shouldChildPanelOpen)}
					usrSelection={usrSelection}
					drawerWidth={drawerWidth}
					fromWhere="filterPanel"
					mtsSubAttr={mtsSubAttr}
					ssiCompatibility={ssiCompatibility}
					cbSSIComptability={updateSSIComptability}
				/>
			);
		}

		if (drawerContent === FILTER_FROM_ALL_DATA) {
			return (
				<PreviewElementContext.Provider
					value={{
						cbSetShowPreviewElement: (fromWhere, shouldKeepOpen = false) =>
							handleShow(fromWhere, shouldKeepOpen),
						cbUsrSelection: (val) => setUsrSelection(val)
					}}>
					<PeviewElements
						selectedListCount={selectedListCount}
						setSelectedListCount={setSelectedListCount}
						customAttribute={customAttribute}
						setTotalSelected={(val) => setTotalSelected(val)}
						totalSelected={totalSelected}
						actionOnGuidedBtn={() => handleShow(LINK_ITEM_ACTIVITY)}
						drawerWidth={drawerWidth}
						panelObjHeader={HEADER_SELECT_FROM_ALL}
						panelObjIcon={
							<IconButton
								style={{ marginRight: 8, marginLeft: -12, padding: 8 }}
								onClick={() => handleShow(FILTER_LOWER, true)}>
								<ArrowBackIcon />
							</IconButton>
						}
						panelObjFromWhere="filter"
						usrSelection={usrSelection}
					/>
				</PreviewElementContext.Provider>
			);
		}

		if (drawerContent === LINK_ITEMS_ACTIVITY) {
			return <LinkedItemsForm cbSetShowPreviewElement={() => handleShow(LINK_ITEM_ACTIVITY)} />;
		}
	};

	const RenderTableLoading = () => {
		return (
			<Backdrop className={classes.backdrop} open={isPreviewLoading}>
				<InputLabel className={classes.previewMsg}>{LOADING_MSG}</InputLabel>
				<Loader />
			</Backdrop>
		);
	};

	const cbOnDialogOkay = () => {
		if (isBackClicked) {
			if (isEditEnabled) {
				handleClear();
				dispatch(editReport({ isEditEnabled: false, editData: {}, action: null }));
				dispatch(
					setSelectedTemplate({
						templateId: null,
						view: null,
						filter: undefined,
						filterWeekly: undefined,
						filterWeeklyMultiWindow: undefined
					})
				);
				navigate('/');
			} else {
				navigate('/rbtemplates');
			}
		} else {
			handleShowPreview();
		}
	};

	const cbOnDialogCancel = () => {
		setIsBackClicked(false);
		setOpenDialog(false);
		setWarnToAddDimensionDialog(false);
	};

	const ShowPreviewDialog = () => {
		let dialogProps = {
			bodyContent: DIALOG_CONTENT,
			secondaryBtnText: KEEP_PREVIEW,
			primaryBtnText: APPLY_FILTER,
			onSecondaryClick: cbOnDialogOkay,
			onPrimaryClick: cbOnDialogCancel
		};

		if (isBackClicked && draftId) {
			const check = isPreviewDisabled();
			dialogProps = {
				title: check ? BACK_WARN_NOTE : DRAFT_SAVE_TITLE,
				bodyContent: check ? BACK_WARN_MSG : DRAFT_SAVE_CONTENT,
				secondaryBtnText: check ? CANCEL_BUTTON : DONT_SAVE,
				primaryBtnText: check ? CONTINUE : SAVE_BUTTON,
				onSecondaryClick: () => {
					if (check) {
						cbOnDialogCancel();
					} else {
						if (isEditEnabled) {
							navigate('/');
						} else {
							navigate('/rbtemplates');
						}
					}
				},
				onPrimaryClick: () => {
					if (check) {
						cbOnDialogOkay();
					} else {
						handleSave(draftName);
					}
				}
			};
		}
		if (isBackClicked && draftId === null) {
			dialogProps = {
				title: DRAFT_SAVE_TITLE,
				bodyContent: DRAFT_SAVE_CONTENT,
				secondaryBtnText: DONT_SAVE,
				primaryBtnText: SAVE_BUTTON,
				onSecondaryClick: () => {
					if (isEditEnabled) {
						navigate('/');
					} else {
						navigate('/rbtemplates');
					}
				},
				onPrimaryClick: () => {
					setShowDraftDialog(true);
					setDraftDialog(SAVE_BUTTON);
				}
			};
		}

		if (
			!isBackClicked &&
			(userPersona === 'MERCHANT' || SHOW_AS_CANNED_REPORT.includes(Number(selectedTemplate)))
		) {
			dialogProps.bodyContent = BLOCKED_PREVIEW_DIALOG_CONTENT;
			dialogProps.primaryBtnText = OK;
			dialogProps.hideTitle = true;
			dialogProps.hidePrimaryBtn = true;
		}

		if (!isBackClicked && !validateDimFilters(selectedList, filterList, Number(selectedTemplate))) {
			dialogProps = {
				title: DIALOG_TITLE_SSI,
				bodyContent: BLOCKED_PREVIEW_DIALOG_CONTENT_SSI,
				primaryBtnText: OK,
				onPrimaryClick: cbOnDialogCancel,
				hidePrimaryBtn: true
			};
		}

		return <DialogBox open={openDialog} {...dialogProps} />;
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
		setIsSaveClicked(false);
	};

	const handleMenuSelect = (val) => {
		dispatch(setMenu(val));
		setAnchorEl(null);
		callRowCountApi();
	};

	const handleSave = (paramDraftName) => {
		if (savedReportsList.length <= MAX_SAVE_DRAFT) {
			// If 'draftName'(from Store) already exists, the Dialog box will be shown to get a new draftName for save operation
			const existingDraftNames = savedReportsList.find((e) => e.draftName === draftName);

			if (!paramDraftName && existingDraftNames) {
				setShowDraftDialog(true);
				setDraftDialog(SAVE_BUTTON);
				return;
			}

			const params = getCommonParams();
			const requestObj = getRequestBody({
				...params,
				persona: userPersona,
				isPreview: false,
				customDatasetDetails
			});

			let computedPivotColumn = null;
			if (hasPivotedColumn(pivotColumn)) {
				if (pivotOpts?.isMultiWeek) {
					computedPivotColumn = PIVOT_MTS_VALUE;
				} else {
					computedPivotColumn = pivotColumn;
				}
			}

			const draftParam = {
				draftId: existingDraftNames?.draftId || null,
				reportType: userPersona,
				templateName: templateName,
				templateId: selectedTemplate,
				linkItemActivity: linkItemActivity,
				draftName: getName(paramDraftName),
				columns: selectedList?.map((item) => item.businessName),
				filtersWithValue: filterList?.map((item) => {
					return {
						...item,
						type: item.dataType
					};
				}),
				runQueryRequestObject: requestObj,
				// check if multiple weeks are selected
				pivotColumn: computedPivotColumn,
				isTimeAcrossDataDown: hasPivotedColumn(pivotColumn) && hasTimeAcross(pivotOpts)
			};

			// If it is custom dataset, then templateId must be 789, customDatasetId & templateName must be set
			if (isCustomDataset(selectedTemplate)) {
				draftParam.templateId = customDatasetDetails?.templateId;
				draftParam.customDatasetId = selectedTemplate;
				draftParam.templateName = customDatasetName;
				// Analytics
				trackEventInfo({
					type: EVENTS.CLICK,
					actionOn: ACTION_ON.CUSTOM_DATASET_SAVE_REPORT,
					location: PAGE_ID.PREVIEW
				});
			}
			dispatch(
				saveDraft({
					requestBody: draftParam,
					companyName
				})
			);
			dispatch(draftPrevSelectedList(deepClone(selectedList)));
			dispatch(draftPrevFilterList(deepClone(filterList)));
			dispatch(draftPrevPivotOption(pivotColumn));

			// Analytics
			trackEventInfo({
				type: EVENTS.CLICK,
				actionOn: `${ACTION_ON.SAVE_REPORT_FROM_PREVIEW} ${templateName}`,
				location: PAGE_ID.PREVIEW
			});

			if (isBackClicked) {
				dispatch(resetDraft());
				if (isEditEnabled) {
					navigate('/');
				} else {
					navigate('/rbtemplates');
				}
			}
			if (isSaveExitClicked) {
				dispatch(resetDraft());
				navigate('/');
			}
			setShowDraftDialog(false);
		} else {
			setShowDraftDialog(false);
			setSnackbar({ open: true, msg: DRAFT_LIMIT_ERROR, type: 'error', guidedBtn: false });
		}
	};

	const DraftReport = () => {
		let dialogProps = {};

		if (draftDialog === SAVE_BUTTON) {
			dialogProps = {
				title: DRAFT_NAME_TITLE,
				bodyContent: DRAFT_NAME_CONTENT,
				secondaryBtnText: CANCEL_BUTTON,
				primaryBtnText: SAVE_BUTTON,
				onSecondaryClick: () => {
					setShowDraftDialog(false);
				},
				onPrimaryClick: handleSave,
				showTextBox: true
			};
		}
		if (draftDialog === REPORT) {
			dialogProps = {
				title: DRAFT_SAVE_TITLE,
				bodyContent: DRAFT_SAVE_CONTENT,
				secondaryBtnText: DONT_SAVE,
				primaryBtnText: SAVE_BUTTON,
				onSecondaryClick: () => {
					setShowDraftDialog(false);
					handleSchedule();
				},
				onPrimaryClick: () => {
					handleSchedule();
					handleSave(draftName);
				}
			};
		}

		return <DialogBox open={showDraftDialog} {...dialogProps} />;
	};

	const onModOnlyPopupCancel = () => {
		setShowModOnlyPopup({ showPopup: false, e: null });
	};

	const onModOnlyPopupOkay = () => {
		handleSchedule(showModOnlyPopup.e);
		onModOnlyPopupCancel();
	};

	const ShowModOnlyDialog = () => {
		const dialogProps = {
			title: '',
			bodyContent: MOD_ONLY_POPUP_TEXT,
			secondaryBtnText: CANCEL_BUTTON,
			primaryBtnText: GOT_IT_BTN,
			onSecondaryClick: onModOnlyPopupCancel,
			onPrimaryClick: onModOnlyPopupOkay,
			hideTitle: true,
			hidePrimaryBtn: false
		};
		return <DialogBox open={showModOnlyPopup.showPopup} {...dialogProps} />;
	};

	const handleToggle = (e) => {
		setAnchorEl(e.currentTarget);
		setIsSaveClicked(true);
	};

	const handleSaveExit = () => {
		if (enablePinned) {
			savePinnedAttributeChanges();
		}
		if (draftId) {
			handleSave(draftName);
			dispatch(resetDraft());
			navigate('/');
			return;
		} else {
			setShowDraftDialog(true);
			setDraftDialog(SAVE_BUTTON);
			setSaveExitClicked(true);
		}
	};

	const handleCreate = (e) => {
		/** For EDIT
		 * 1. When there is no change in selection list and filterlist,
		 * - Show dropdown - update and create a copy
		 * 2. When there is change in selection and filterlist
		 * - Show dialogbox
		 * 2.1 If draftId not defined => SAVE_BUTTON
		 * 2.2 If draftId is mentioned => REPORT
		 */
		let isSomethingChanged = true;
		const isSelChg = compareObj(selectedList, prevSelectedList);
		const isSFilterChg = compareObj(filterList, prevFilterList);
		// if both true => then no change
		if (isSelChg && isSFilterChg) {
			isSomethingChanged = false;
		}
		setCreateReportAnchor(e);
		if (
			draftId &&
			!isPreviewDisabled() &&
			isSomethingChanged &&
			reportTypeTabValue === 1 &&
			isEditEnabled
		) {
			setShowDraftDialog(true);
			setDraftDialog(REPORT);
		} else {
			//If it is a custom dataset report and mod only options are selected for filters/columns, then show a popup first
			const isCustomDS = isCustomDataset(selectedTemplate);
			if (isCustomDS) {
				const selectedListWithoutTime = selectedList.filter(
					(listItem) => !TIME_BUSINESS_NAMES.includes(listItem.businessName)
				);
				const isModOnlySelectedList = isCustomDatasetModular(selectedListWithoutTime);
				const filterListWithoutTime = filterList.filter(
					(listItem) => !TIME_BUSINESS_NAMES.includes(listItem.businessName)
				);
				const isModOnlyFilterList = isCustomDatasetModular(filterListWithoutTime);

				const isTimeFilterApplied = filterList.some((listItem) =>
					TIME_BUSINESS_NAMES.includes(listItem.businessName)
				);
				// If all the selectd columns and filters belong to Modular and Time filter is applied, then we show the warning popup
				if (isModOnlySelectedList && isModOnlyFilterList && isTimeFilterApplied) {
					setShowModOnlyPopup({
						showPopup: true,
						e: { currentTarget: e?.currentTarget }
					});
					return;
				}
			}
			handleSchedule(e);
		}

		if (enablePinned) {
			savePinnedAttributeChanges();
		}
	};

	const hideSnackbar = () => {
		if (openSnackbar.open) {
			setSnackbar({ open: false, msg: '', guidedBtn: false });
		}
	};

	const getName = (paramDraftName) => {
		if (paramDraftName) {
			return paramDraftName;
		}
		if (isEditEnabled) {
			return reportTypeTabValue === 0 ? editData.reportName : editData.draftName;
		}
		/** if brand new report get saved on preview page then need to show draft name from the dialogbox*/
		return draftName;
	};

	const btnGroupCls = classNames({
		[classes.button]: !isSaveDisabled(),
		[classes.disabledButton]: isSaveDisabled()
	});

	const handleTooltipClose = () => {
		setTooltipOpen(false);
	};

	const isCDS = isCustomDataset(selectedTemplate);

	const button = (
		<Button
			id="btn-preview"
			disabled={shouldDisable(true)}
			onClick={handlePreviewClick}
			startIcon={<VisibilityOutlinedIcon />}
			className={`${classes.button} ${classes.buttonSave}`}>
			{PREVIEW}
		</Button>
	);

	return (
		<Box className="preview-container" style={{ overflowY: 'hidden' }}>
			<Box className={classes.root} style={{ zIndex: 2 }}>
				<AppBar position="fixed" className={classes.appBar}>
					<Toolbar className={classes.toolbar}>
						<Box style={{ display: 'flex', justifyContent: 'center' }}>
							<IconButton
								id="toolbar-back"
								size="medium"
								onClick={() => handleBack()}
								aria-label="Back">
								<ChevronLeftIcon fontSize="large" />
							</IconButton>
							<Box style={{ margin: '8px' }}>
								<InputLabel className={classes.draftName}>{draftName}</InputLabel>
								{!isCustomDataset(selectedTemplate) && (
									<InputLabel className={classes.templateName}>{templateName}</InputLabel>
								)}
							</Box>
						</Box>
						<Box style={{ display: 'flex', alignItems: 'center' }}>
							{disablePreview && (
								<ClickAwayListener onClickAway={handleTooltipClose}>
									<Box>
										<Tooltip
											onOpen={() => setTooltipOpen(true)}
											open={tooltipOpen}
											title={
												<>
													<Box className={classes.tooltipContainer}>
														<VisibilityOutlinedIcon className={classes.visibilityIcon} />
														<Typography className={classes.tooltipHeader}>{PREVIEW}</Typography>
														<LockOutlinedIcon className={classes.lockIcon}></LockOutlinedIcon>
													</Box>
													<Typography className={classes.tooltipContent}>
														{PREVIEW_TOOLTIP_FOR_BASIC}
													</Typography>
													<Button
														id="learnMoreAbtCharterBtn"
														onClick={() => {
															window.open(
																`${getBaseUrl()}${LUMINATE_PLANS_LINK}`,
																'_blank',
																'noreferrer'
															);
															handleTooltipClose();
														}}
														className={classes.tooltipBtn}>
														{LEARN_MORE}
													</Button>
												</>
											}
											arrow
											classes={{ arrow: classes.arrow, tooltip: classes.tooltip }}
											disableFocusListener
											disableHoverListener
											disableTouchListener>
											<span
												onMouseEnter={() => setTooltipOpen(true)}
												onFocus={() => setTooltipOpen(true)}
												onTouchStart={() => setTooltipOpen(true)}>
												<Button
													id="btn-preview"
													disabled={shouldDisable(true)}
													onClick={handlePreviewClick}
													startIcon={<VisibilityOutlinedIcon />}
													className={`${classes.button} ${classes.buttonPreview}`}>
													{PREVIEW}
													<LockOutlinedIcon className={classes.lockIcon}></LockOutlinedIcon>
												</Button>
											</span>
										</Tooltip>
									</Box>
								</ClickAwayListener>
							)}

							<ButtonGroup
								variant="contained"
								color="primary"
								className={btnGroupCls}
								disabled={isSaveDisabled()}
								aria-label="split button">
								<Button
									id="btn-save"
									disabled={isSaveDisabled()}
									startIcon={<SaveOutlinedIcon />}
									onClick={() => {
										if (draftId) {
											handleSave(draftName);
										} else {
											setShowDraftDialog(true);
											setDraftDialog(SAVE_BUTTON);
										}
									}}
									className={`${classes.customButton} ${classes.buttonSave}`}>
									{SAVE_BUTTON}
								</Button>
								<Button
									id="btn-save-exit"
									onClick={handleToggle}
									className={`${classes.customButton} ${classes.buttonDrop}`}>
									<ArrowDropDownIcon />
								</Button>
							</ButtonGroup>
							{!disablePreview && isCDS && (
								<ClickAwayListener onClickAway={() => setIsPreviewTooltipOpen(false)}>
									<Tooltip
										onOpen={() => setIsPreviewTooltipOpen(true)}
										open={isPreviewTooltipOpen}
										title={PREVIEW_NOT_AVAILABLE_TOOLTIP}
										arrow
										disableFocusListener
										disableHoverListener
										disableTouchListener>
										<span
											onMouseEnter={() => setIsPreviewTooltipOpen(true)}
											onMouseLeave={() => setIsPreviewTooltipOpen(false)}
											onFocus={() => setIsPreviewTooltipOpen(true)}
											onTouchStart={() => setIsPreviewTooltipOpen(true)}>
											{button}
										</span>
									</Tooltip>
								</ClickAwayListener>
							)}
							{!disablePreview && !isCDS && <>{button}</>}
							<Button
								id="btn-schedule"
								disabled={shouldDisable(false)}
								onClick={handleCreate}
								startIcon={<img className={classes.createReportIcon} src={CreateReportIcon} />}
								className={`${classes.button} ${classes.buttonSchedule}`}>
								{REPORT}
							</Button>
							<ScheduleMenu
								anchor={anchorEl}
								cbOnClose={handleMenuClose}
								cbMenuSelect={isSaveClicked ? handleSaveExit : handleMenuSelect}
								menu={isSaveClicked ? OPTIONS : MENU}
							/>
							<HelpMenu cbSetShowPreviewElement={() => handleShow(COLUMNS_LOWER, true)} />
						</Box>
					</Toolbar>
				</AppBar>

				<Grid container direction="row">
					<Grid container>
						<Grid item xs={12} sm={6} md={8} lg={9}>
							<Box className={classes.tableContainer}>
								<PreviewElementContext.Provider
									value={{
										cbSetShowPreviewElement: (fromWhere, shouldKeepOpen = false) =>
											handleShow(fromWhere, shouldKeepOpen),
										cbUsrSelection: (val) => setUsrSelection(val),
										cbSetFilterTooltip: (val) => setFilterTooltip(val)
									}}>
									<PreviewTable
										clearPreviewLoaded={dispatchActionClearPreviewLoaded}
										setSelectedListCount={setSelectedListCount}
										selectedListCount={selectedListCount}
										setTotalSelected={setTotalSelected}
										reloadPreview={reloadPreview}
										isLinkedItemPanelOpened={isLinkedItemPanelOpened}
										isColumnPanelOpened={isColumnPanelOpened}
										isFilterPanelOpened={isFilterPanelOpened}
										renderDrawerContent={renderDrawerContent}
										show={openDrawer}
										filterTooltip={filterTooltip}
										cbSSIComptability={updateSSIComptability}
										ssiCompatibility={ssiCompatibility}
									/>
								</PreviewElementContext.Provider>
							</Box>
						</Grid>
					</Grid>
				</Grid>
			</Box>
			<RenderTableLoading />
			<ShowPreviewDialog />
			<TourStarter show={showTourStarter} onTourStart={onTourStart} />
			<DraftReport />
			<ShowModOnlyDialog />
			<AttrWarningOnMTS />
			<AttrWarningOnSSIIncomp />
			<ShowWarnToAddDimensionDialog />
			<OTIFDialog />
			<RBSnackbar
				doOpen={openSnackbar.open}
				msg={openSnackbar.msg}
				doClose={hideSnackbar}
				guidedBtn={openSnackbar.guidedBtn}
				type={openSnackbar.type}
				hideDuration={openSnackbar?.hideDuration}
			/>
		</Box>
	);
};

Preview.propTypes = {};

export default Preview;
